import { Button } from '@sweep-io/sweep-design';
import { ButtonProps } from '@sweep-io/sweep-design/dist/components/Button';

export const PageTemplateActionButton = (props: ButtonProps) => {
  return <Button {...props} size="small" variant="system" />;
};
